import { Label, Ref, Span, Div, Text, RefComponentBase } from "@tblabs/truffle";
import { primitive } from "@tblabs/truffle/Core/primitive";


export class RadioInput extends RefComponentBase<primitive, HTMLInputElement>
{
    constructor(ref: Ref<primitive>, private value: primitive, uniqueId: string)
    {
        super("input", ref);

        this.Attribute("type", "radio");
        this.Attribute("name", uniqueId);
        this.Attribute("value", value.toString());

        this.On('input', () =>
        {
            this.ref.value = value;
            this.Refresh();
        });

        this.Refresh();
    }

    public Refresh()
    {
        const checked = this.ref.value == this.value;

        this.element.checked = checked;
    }
}

export class XRadioOption<T extends primitive> extends Label
{
    private input = new RadioInput(this.ref, this.activator, this.group);

    constructor(
        private group: string,
        private ref: Ref<T>,
        private activator: T,
        title: string,
        description: string,
        price?: string | Ref<number>,
        testId?: string)
    {
        super();
        if (testId)
            this.Attribute("data-testid", testId);

        this.Append(
            this.input,
            new Span().Class("radio-option__indicator"),
            new Div("radio-option__content").Append(
                new Span(title).Class("radio-option__title"),
                new Span(description).Class("radio-option__description"),
                price && (price instanceof Ref
                    ? new Text(price, v => v + " zł").Class("radio-option__price")
                    : new Span(price).Class("radio-option__price"))
            ),
        );

        this.Class("radio-option");
    }

    public Disabled(): this
    {
        this.input.Disabled();
        this.Opacity(0.20);

        return this;
    }

    public Enable(v: Ref<boolean>): this
    {
        v.OnChange(x =>
        {
            this.Opacity(x ? 1 : 0.20);
            this.input.Enable(x);
        }, true);

        return this;
    }
}
